import React from 'react';

import { background, padding, useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import {
    Alignment,
    ColorPalette,
    ColorVariant,
    FlexBox,
    Orientation,
    Size,
    Text,
    Typography,
} from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { SCOPE } from '../../../constants';
import { WREX_COLUMNS } from '../../../keys';

import './index.scss';

const CLASSNAME = 'wrex-content-column-placeholder';

export const Placeholder: React.FC = () => {
    const { block, element } = useClassnames(CLASSNAME);
    const { get } = useDataAttributes(SCOPE);
    const { translateKey } = useTranslate();

    return (
        <FlexBox
            className={block()}
            contentEditable={false}
            orientation={Orientation.vertical}
            hAlign={Alignment.center}
            tabIndex={-1}
        >
            <FlexBox
                orientation={Orientation.vertical}
                hAlign={Alignment.center}
                vAlign={Alignment.center}
                className={element('content', [
                    padding('vertical', Size.big),
                    padding('horizontal'),
                    background(ColorPalette.dark, ColorVariant.L6),
                ])}
            >
                <Text
                    as="span"
                    color={ColorPalette.dark}
                    colorVariant={ColorVariant.L2}
                    typography={Typography.caption}
                    {...get({ element: 'placeholder' })}
                >
                    {translateKey(WREX_COLUMNS.ADD_CONTENT_HERE)}
                </Text>
            </FlexBox>
        </FlexBox>
    );
};
